import React from 'react';

export function CellInput({ value, onChange, numeric, disabled }) {
  return (
    <input
      type={numeric ? 'number' : 'text'}
      value={value === null || value === undefined ? '' : value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      step="0.01"
      className="w-full px-1.5 py-1 rounded-md bg-white border border-sky-300 text-[12px] focus:outline-none focus:ring-1 focus:ring-sky-400 disabled:bg-slate-100 disabled:text-slate-400"
    />
  );
}

export const StatusPill = ({ value }) => {
  if (!value) return <span className="text-slate-400">—</span>;
  const v = String(value).toLowerCase();
  let cls = 'bg-slate-100 text-slate-600 border-slate-200';
  if (v.includes('complete') || v.includes('deliver') || v.includes('invoice')) cls = 'bg-emerald-50 text-emerald-700 border-emerald-200';
  else if (v.includes('queue') || v.includes('pending')) cls = 'bg-amber-50 text-amber-700 border-amber-200';
  else if (v.includes('progress') || v.includes('repair')) cls = 'bg-blue-50 text-blue-700 border-blue-200';
  else if (v.includes('cancel')) cls = 'bg-rose-50 text-rose-700 border-rose-200';
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border ${cls}`}>{value}</span>;
};
